/* Pagine categoria DR - Digital Runner
   - Catalogo: filtri (linea, tipo, prezzo, promo, novita'), ordinamento, "Mostra altri",
     filtri salvati nell'indirizzo (?linea=A,B&tipo=Crema%20viso&prezzo=lt10&promo=1&novita=1&ordina=asc&coll=handle)
   - Riquadri per collezione (data-cp-coll): filtrano i prodotti del catalogo che stanno in quella collezione
   - Riquadri esigenze: filtrano il catalogo e scorrono fino a lui; ricerca tra i riquadri
   - Pulsanti con data-cp-go="catalogo|promo|novita" (hero, sezioni prodotti)
   - Carosello promo; tastiera su <add-to-cart> di Be Yours
   Tutto passa da eventi sul document: le sezioni restano indipendenti e riordinabili. */
(function () {
  // il file e' incluso da piu' sezioni: va eseguito una volta sola
  if (window.__cpDrLoaded) return;
  window.__cpDrLoaded = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PRICE_LABEL = { lt10: 'Fino a €10', '10-20': '€10 – €20', gt20: 'Oltre €20' };

  function $all(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function catalog() { return document.querySelector('[data-cp-catalog]'); }

  function scrollToEl(el) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - 12;
    window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
  }

  /* ---------------- Catalogo ---------------- */
  function initCatalog(root) {
    var grid = root.querySelector('[data-cp-grid]');
    if (!grid) return;
    var items = $all(grid, '[data-cp-item]');
    var perPage = parseInt(root.dataset.perPage, 10) || 24;
    var alias = {};
    try { alias = JSON.parse(root.dataset.alias || '{}'); } catch (e) {}
    window.__cpAlias = alias;
    function norm(list) {
      var out = [];
      list.forEach(function (x) { x = alias[x.trim()] || x.trim(); if (x && out.indexOf(x) === -1) out.push(x); });
      return out;
    }
    var shown = perPage;
    var st = { linee: [], tipi: [], prezzo: 'all', promo: false, novita: false, ordina: 'feat', coll: '', collLabel: '' };

    var elCount = root.querySelector('[data-cp-count]');
    var elChips = root.querySelector('[data-cp-chips]');
    var elEmpty = root.querySelector('[data-cp-empty]');
    var elMore = root.querySelector('[data-cp-more]');
    var elSort = root.querySelector('[data-cp-sort]');
    var elAside = root.querySelector('[data-cp-aside]');
    var elOpen = root.querySelector('[data-cp-open-filters]');
    var elFCount = root.querySelector('[data-cp-filter-count]');
    var resets = $all(root, '[data-cp-reset]');
    var boxes = $all(root, '[data-cp-linea]');
    var tboxes = $all(root, '[data-cp-tipo]');
    var radios = $all(root, '[data-cp-price]');
    var flags = $all(root, '[data-cp-flag]');

    function inPrice(cents) {
      var e = cents / 100;
      switch (st.prezzo) {
        case 'lt10': return e < 10;
        case '10-20': return e >= 10 && e <= 20;
        case 'gt20': return e > 20;
        default: return true;
      }
    }

    function match(it) {
      if (st.linee.length) {
        var l = it.dataset.linea || '';
        var ok = st.linee.some(function (x) { return l.indexOf('|' + x + '|') !== -1; });
        if (!ok) return false;
      }
      if (st.coll && (it.dataset.coll || '').indexOf('|' + st.coll + '|') === -1) return false;
      if (st.tipi.length && st.tipi.indexOf(it.dataset.tipo || '') === -1) return false;
      if (!inPrice(parseInt(it.dataset.price, 10) || 0)) return false;
      if (st.promo && it.dataset.promo !== '1') return false;
      if (st.novita && it.dataset.new !== '1') return false;
      return true;
    }

    function sorter(a, b) {
      var pa = parseInt(a.dataset.price, 10), pb = parseInt(b.dataset.price, 10);
      switch (st.ordina) {
        case 'asc': return pa - pb || a.dataset.i - b.dataset.i;
        case 'desc': return pb - pa || a.dataset.i - b.dataset.i;
        case 'az': return a.dataset.title.localeCompare(b.dataset.title, 'it');
        default: return a.dataset.i - b.dataset.i;
      }
    }

    function syncControls() {
      boxes.forEach(function (b) { b.checked = st.linee.indexOf(b.value) !== -1; });
      tboxes.forEach(function (b) { b.checked = st.tipi.indexOf(b.value) !== -1; });
      radios.forEach(function (r) { r.checked = r.value === st.prezzo; });
      flags.forEach(function (f) { f.checked = f.dataset.cpFlag === 'promo' ? st.promo : st.novita; });
      if (elSort) elSort.value = st.ordina;
    }

    function chip(label, fn) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cp-chip_dr';
      b.setAttribute('aria-label', 'Togli filtro: ' + label);
      b.innerHTML = '<span></span><span aria-hidden="true">×</span>';
      b.firstChild.textContent = label;
      b.addEventListener('click', fn);
      return b;
    }

    function writeUrl() {
      try {
        var u = new URL(window.location.href);
        ['linea', 'tipo', 'prezzo', 'promo', 'novita', 'ordina', 'coll'].forEach(function (k) { u.searchParams.delete(k); });
        if (st.linee.length) u.searchParams.set('linea', st.linee.join(','));
        if (st.tipi.length) u.searchParams.set('tipo', st.tipi.join(','));
        if (st.prezzo !== 'all') u.searchParams.set('prezzo', st.prezzo);
        if (st.promo) u.searchParams.set('promo', '1');
        if (st.novita) u.searchParams.set('novita', '1');
        if (st.ordina !== 'feat') u.searchParams.set('ordina', st.ordina);
        if (st.coll) u.searchParams.set('coll', st.coll);
        window.history.replaceState(window.history.state, '', u.toString());
      } catch (e) {}
    }

    function readUrl() {
      try {
        var q = new URL(window.location.href).searchParams;
        var valid = boxes.map(function (b) { return b.value; });
        if (q.get('linea')) st.linee = q.get('linea').split(',').filter(function (x) { return valid.indexOf(x) !== -1; });
        var tvalid = tboxes.map(function (b) { return b.value; });
        if (q.get('tipo')) st.tipi = q.get('tipo').split(',').filter(function (x) { return tvalid.indexOf(x) !== -1; });
        if (PRICE_LABEL[q.get('prezzo')]) st.prezzo = q.get('prezzo');
        st.promo = q.get('promo') === '1';
        st.novita = q.get('novita') === '1';
        if (['asc', 'desc', 'az'].indexOf(q.get('ordina')) !== -1) st.ordina = q.get('ordina');
        if (q.get('coll')) {
          st.coll = q.get('coll');
          var tl = $all(document, '[data-cp-coll]').filter(function (t) { return t.dataset.cpColl === st.coll; })[0];
          var nm = tl && tl.querySelector('.cp-need__name_dr');
          st.collLabel = nm ? nm.textContent.trim() : st.coll;
        }
      } catch (e) {}
    }

    function render(keepShown) {
      if (!keepShown) shown = perPage;
      var list = items.filter(match).sort(sorter);
      items.forEach(function (it) { it.hidden = true; });
      list.forEach(function (it, i) {
        grid.appendChild(it); // riordina nel DOM
        it.hidden = i >= shown;
      });
      var n = list.length;
      if (elCount) elCount.textContent = n + (n === 1 ? ' prodotto' : ' prodotti');
      if (elEmpty) elEmpty.hidden = n > 0;
      if (elMore) {
        elMore.hidden = n <= shown;
        elMore.textContent = 'Mostra altri prodotti (' + Math.max(0, n - shown) + ')';
      }

      var active = (st.coll ? 1 : 0) + st.linee.length + st.tipi.length + (st.prezzo !== 'all' ? 1 : 0) + (st.promo ? 1 : 0) + (st.novita ? 1 : 0);
      if (elFCount) elFCount.textContent = active ? '(' + active + ')' : '';
      resets.forEach(function (r) { if (r.closest('[data-cp-empty]')) return; r.hidden = active === 0; });
      if (elChips) {
        elChips.innerHTML = '';
        if (st.coll) elChips.appendChild(chip(st.collLabel || st.coll, function () { st.coll = ''; st.collLabel = ''; update(); }));
        st.linee.forEach(function (l) {
          elChips.appendChild(chip(l, function () { st.linee = st.linee.filter(function (x) { return x !== l; }); update(); }));
        });
        st.tipi.forEach(function (t) {
          elChips.appendChild(chip(t, function () { st.tipi = st.tipi.filter(function (x) { return x !== t; }); update(); }));
        });
        if (st.prezzo !== 'all') elChips.appendChild(chip(PRICE_LABEL[st.prezzo], function () { st.prezzo = 'all'; update(); }));
        if (st.promo) elChips.appendChild(chip('In promozione', function () { st.promo = false; update(); }));
        if (st.novita) elChips.appendChild(chip('Novità', function () { st.novita = false; update(); }));
      }
      document.dispatchEvent(new CustomEvent('cp:state', { detail: { linee: st.linee.slice(), coll: st.coll } }));
    }

    function update(keepShown) { syncControls(); render(keepShown); writeUrl(); }

    boxes.forEach(function (b) {
      b.addEventListener('change', function () {
        st.linee = boxes.filter(function (x) { return x.checked; }).map(function (x) { return x.value; });
        update();
      });
    });
    tboxes.forEach(function (b) {
      b.addEventListener('change', function () {
        st.tipi = tboxes.filter(function (x) { return x.checked; }).map(function (x) { return x.value; });
        update();
      });
    });
    radios.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) { st.prezzo = r.value; update(); } }); });
    flags.forEach(function (f) {
      f.addEventListener('change', function () {
        if (f.dataset.cpFlag === 'promo') st.promo = f.checked; else st.novita = f.checked;
        update();
      });
    });
    if (elSort) elSort.addEventListener('change', function () { st.ordina = elSort.value; update(); });
    resets.forEach(function (r) {
      r.addEventListener('click', function () { st.linee = []; st.tipi = []; st.prezzo = 'all'; st.promo = false; st.novita = false; st.coll = ''; st.collLabel = ''; update(); });
    });
    if (elMore) elMore.addEventListener('click', function () { shown += perPage; render(true); });

    // Filtri su mobile: pannello apri/chiudi
    function setOpen(open) {
      root.classList.toggle('is-filters-open', open);
      if (elOpen) elOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    if (elOpen) elOpen.addEventListener('click', function () { setOpen(!root.classList.contains('is-filters-open')); });
    $all(root, '[data-cp-close-filters]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); scrollToEl(root); });
    });

    // Richieste dalle altre sezioni (riquadri, hero, promo, novita')
    document.addEventListener('cp:filter', function (e) {
      var d = e.detail || {};
      if (d.reset) { st.linee = []; st.tipi = []; st.prezzo = 'all'; st.promo = false; st.novita = false; st.coll = ''; st.collLabel = ''; }
      if (d.linee) {
        var valid = boxes.map(function (b) { return b.value; });
        st.linee = norm(d.linee).filter(function (x) { return valid.indexOf(x) !== -1; });
      }
      if (typeof d.coll === 'string') { st.coll = d.coll; st.collLabel = d.collLabel || ''; }
      if (typeof d.promo === 'boolean') st.promo = d.promo;
      if (typeof d.novita === 'boolean') st.novita = d.novita;
      update();
      if (d.scroll !== false) scrollToEl(root);
    });

    readUrl();
    update(true);
  }

  /* ---------------- Gruppi di filtri lunghi (es. Tipo di prodotto) ----------------
     Ordina le voci dalla piu' numerosa, ne mostra le prime N e aggiunge "Mostra tutti".
     Una voce spuntata resta sempre visibile. */
  function initCollapse(fs, root) {
    var max = parseInt(fs.dataset.cpCollapse, 10) || 8;
    var labels = $all(fs, '.cp-check_dr');
    function cnt(l) { var c = l.querySelector('.cp-check__count_dr'); return c ? parseInt(c.textContent, 10) || 0 : 0; }
    labels.sort(function (a, b) { return cnt(b) - cnt(a) || a.textContent.trim().localeCompare(b.textContent.trim(), 'it'); });
    labels.forEach(function (l) { fs.appendChild(l); });
    if (labels.length <= max + 2) return; // per 1-2 voci in piu' non serve il pulsante
    var open = false;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cp-cat__toggle_dr';
    btn.style.cssText = 'display:inline-block;margin-top:6px;padding:4px 0;border:0;background:none;font:inherit;font-size:15px;font-weight:600;text-decoration:underline;text-underline-offset:3px;color:inherit;cursor:pointer';
    fs.appendChild(btn);
    function refresh() {
      labels.forEach(function (l, i) {
        var inp = l.querySelector('input');
        l.hidden = !open && i >= max && !(inp && inp.checked);
      });
      btn.textContent = open ? 'Mostra meno' : 'Mostra tutti (' + labels.length + ')';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    btn.addEventListener('click', function () { open = !open; refresh(); });
    document.addEventListener('cp:state', refresh);
    refresh();
  }

  /* ---------------- Riquadri esigenze ---------------- */
  function initNeeds(root) {
    var tiles = $all(root, '[data-cp-need]');
    var q = root.querySelector('[data-cp-needs-q]');
    var empty = root.querySelector('[data-cp-needs-empty]');

    root.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-cp-need]');
      if (!t || !catalog()) return; // senza catalogo: segue il link del blocco
      e.preventDefault();
      var already = t.getAttribute('aria-current') === 'true';
      if (t.dataset.cpColl) {
        var nm = t.querySelector('.cp-need__name_dr');
        document.dispatchEvent(new CustomEvent('cp:filter', { detail: { reset: true, coll: already ? '' : t.dataset.cpColl, collLabel: nm ? nm.textContent.trim() : '' } }));
        return;
      }
      var vals = t.dataset.cpNeed.split('|');
      document.dispatchEvent(new CustomEvent('cp:filter', { detail: { reset: true, linee: already ? [] : vals } }));
    });

    document.addEventListener('cp:state', function (e) {
      var on = (e.detail && e.detail.linee) || [];
      var onColl = (e.detail && e.detail.coll) || '';
      tiles.forEach(function (t) {
        if (t.dataset.cpColl) {
          if (onColl && onColl === t.dataset.cpColl && !on.length) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
          return;
        }
        var map = window.__cpAlias || {};
        var vals = [];
        t.dataset.cpNeed.split('|').forEach(function (v) { v = map[v] || v; if (vals.indexOf(v) === -1) vals.push(v); });
        var active = !onColl && on.length > 0 && vals.every(function (v) { return on.indexOf(v) !== -1; }) && on.length === vals.length;
        if (active) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    });

    if (q) {
      q.addEventListener('input', function () {
        var s = q.value.trim().toLowerCase();
        var visible = 0;
        tiles.forEach(function (t) {
          var ok = !s || t.dataset.cpName.indexOf(s) !== -1 || t.dataset.cpNeed.toLowerCase().indexOf(s) !== -1;
          t.hidden = !ok;
          if (ok) visible++;
        });
        if (empty) empty.hidden = visible > 0;
      });
    }
  }

  /* ---------------- Carosello ---------------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-cp-track]');
    if (!track) return;
    var prev = root.querySelector('[data-cp-prev]');
    var next = root.querySelector('[data-cp-next]');
    function go(dir) { track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: reduce ? 'auto' : 'smooth' }); }
    function upd() {
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(upd, 60); }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------------- Collegamenti globali ---------------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cp-go]');
    if (!a) return;
    var cat = catalog();
    if (!cat) return; // nessun catalogo: il link #catalogo resta un'ancora
    e.preventDefault();
    var go = a.getAttribute('data-cp-go');
    var d = { reset: true };
    if (go === 'promo') d.promo = true;
    if (go === 'novita') d.novita = true;
    if (go === 'catalogo') { scrollToEl(cat); return; }
    document.dispatchEvent(new CustomEvent('cp:filter', { detail: d }));
  });

  // <add-to-cart> di Be Yours gestisce solo il click: aggiungo Invio / Spazio
  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest && e.target.closest('add-to-cart.cp-card__add_dr');
    if (btn && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); btn.click(); }
  });

  function init(scope) {
    var s = scope || document;
    // prima i riquadri, poi il catalogo: cosi' ricevono lo stato iniziale letto dall'indirizzo
    $all(s, '[data-cp-needs]').forEach(function (r) { if (!r.dataset.cpReady) { r.dataset.cpReady = '1'; initNeeds(r); } });
    $all(s, '[data-cp-carousel]').forEach(function (r) { if (!r.dataset.cpReady) { r.dataset.cpReady = '1'; initCarousel(r); } });
    $all(s, '[data-cp-collapse]').forEach(function (r) { if (!r.dataset.cpReady) { r.dataset.cpReady = '1'; initCollapse(r); } });
    $all(s, '[data-cp-catalog]').forEach(function (r) { if (!r.dataset.cpReady) { r.dataset.cpReady = '1'; initCatalog(r); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
